import { AttributesMixin, define, Model, type } from "@type-r/models";
import { AssetStateIds } from "../../api/assetStateIds";
import { AssetType } from "../../api/assetType";
import { DateFilter, formatDateFilter } from "../../components/search-bar/filters/date-filter";
import { MultiSelectChipsFilter } from "../../components/search-bar/filters/multiselect-chips-filter";
import { TextFilter } from "../../components/search-bar/filters/text-filter";


const defaultSort = {
    attr: "createdOn",
    asc: false
};

export const SortOptions = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}

export const RemittanceAdviceStateOptions = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: AssetStateIds.Pending,
        label: 'Pending'
    },
    {
        value: AssetStateIds.Digitized,
        label: 'Digitized'
    }
]

export interface UnappliedCashFilter extends AttributesMixin<typeof UnappliedCashFilter> { }

@define
export class UnappliedCashFilter extends Model {
    static attributes = {
        filterAll: '',
        payors: type(MultiSelectChipsFilter),
        payees: type(MultiSelectChipsFilter),
        amount: type(TextFilter),
        currency: type(TextFilter),
        effectiveDate: type(DateFilter),
        referenceNumber: type(TextFilter),
        assetUid: type(TextFilter),
        stateId: 0,
        sortBy: type(defaultSort),
    }

    reset() {
        this.filterAll = '';
        this.payors.$.selected.set([] as any);
        this.payees.$.selected.set([] as any);
        this.amount.$.value.set('');
        this.currency.$.value.set('');
        this.effectiveDate.$.date.set(null);
        this.referenceNumber.$.value.set('');
        this.assetUid.$.value.set('');
    }

    mapToQuery(skip: number = 0, take: number = 30, stateId?: number) {
        const params: any = { skip: skip, count: take, assetTypeId: AssetType.unappliedCash };

        if (this.payors.selected && this.payors.selected.length) {
            params.payors = this.payors.selected;
            params.payors = params.payors.join('|');
        }
        else if (this.payees.selected && this.payees.selected.length) {
            params.payees = this.payees.selected;
            params.payees = params.payees.join('|');
        }
        else if (this.amount.value) {
            params.amount = this.amount.value;
        }
        else if (this.currency.value) {
            params.currency = this.currency.value;
        }
        else if (this.effectiveDate.date) {
            params.effectiveDate = formatDateFilter(this.effectiveDate.date);
        }
        else if (this.filterAll && this.filterAll.length > 2) {
            params.matchAll = this.filterAll;
        }
        else if (this.referenceNumber.value) {
            params.referenceNumber = this.referenceNumber.value
        }
        else if (this.assetUid.value) {
            params.uid = this.assetUid.value;
        }

        if (stateId > 0) {
            params.stateId = stateId;
        }
        else if (this.stateId > 0) {
            params.stateId = this.stateId;
        }

        if (this.sortBy) {
            params.sortBy = this.sortBy.attr;
            params.sortDirection = this.sortBy.asc ? 'asc' : 'desc';
        }

        return params;
    }
}